import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { TesteEmail } from '../models/teste-email';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private http: HttpClient) {

  }

  testarEnvio(teste: TesteEmail) {
    return this.http.post(globals.apiUrl + '/api/email/TestarEnvio', teste);
  }
}
